import React, { createContext, useState } from 'react';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [pageList] = useState([
        { title: "Home", path: "/" },
        { title: "Gallery", path: "/gallery" },
        { title: "Commissions", path: "/commissions" },
    ]);

    const [commissionsOpen] = useState(true);

    return (
        <GlobalContext.Provider value={{ pageList, commissionsOpen }}>
            {children}
        </GlobalContext.Provider>
    );
};